// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3XMhG","label":"Section_label__25AAG","contentWrap":"Section_contentWrap__2Rvl3","footer":"Section_footer__17fXt","footerInner":"Section_footerInner__Arm30"};